import { useParams } from 'react-router-dom';
import { Box, Typography, Container } from '@mui/material';
import { useState, useEffect } from 'react';
import commercialInfo from '../data/commercial-info.json';

const Comercial = () => {
  const { commercialName } = useParams();
  const [videoData, setVideoData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const commercial = commercialInfo.find((c) => c.slug === commercialName);
    if (commercial) {
      setVideoData(commercial);
    } else {
      setError('Commercial not found');
    }
  }, [commercialName]);

  if (error) {
    return (
      <Container>
        <Typography variant="h4" color="error" sx={{ mt: 4 }}>
          {error}
        </Typography>
      </Container>
    );
  }

  if (!videoData) {
    return (
      <Container>
        <Typography>Loading...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 12 }}>
      <Box
        sx={{
          mt: 4,
          mb: 4,
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            paddingTop: '56.25%', // 16:9 aspect ratio
          }}
        >
          <iframe
            src={videoData.videoUrl}
            title={videoData.title || 'Commercial'}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
            }}
            allow="autoplay; fullscreen; encrypted-media"
            allowFullScreen
          />
        </Box>
      </Box>
    </Container>
  );
};

export default Comercial;
